import { DateTime } from 'luxon';

export const toJSDate = (v: string) => {
  return DateTime.fromISO(v).toJSDate();
};
